import { render, staticRenderFns } from "./bar-two.vue?vue&type=template&id=ba35469c&"
import script from "./bar-two.vue?vue&type=script&lang=js&"
export * from "./bar-two.vue?vue&type=script&lang=js&"
import style0 from "./bar-two.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports